import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import Typography from 'material-ui/Typography';
import MainTheme from '../../../../components/main/layout/theme';
import Footer from '../../../../components/main/footer';
import Header from '../../../../components/main/header';
import PDFViewer from '../../../../components/main/files/pdf-viewer';
import Dashboard from '../../../../components/main/files/pdf-viewer-dashboard';
import Fullscreen from '../../../../components/common/fullscreen';
import styles from './styles';

const PDFPage = props => {
	const {
		url, title, classes, file,
		handleGoBack, onLoadListener,
		pageNumber, setPageNumber, pageNumbers,
		setFullscreen, isFullscreen,
		zoomIn, zoomOut, width
	} = props;

	const dashboardProps = {
		pageNumber,
		pageNumbers,
		setPageNumber,
		zoomIn,
		zoomOut,
		setFullscreen
	};
	const fullscreenProps = {
		enabled: isFullscreen,
		onChange: (isFull => setFullscreen(isFull))
	};
	const pdfViewerProps = {
		url, width, onLoadListener
	};

	return (
		<MainTheme>
			<Header
				title={title}
				classes={{container: classes.header}}
				handleGoBack={handleGoBack}
				isHomepage={false}
			/>
			<div className={classes.pdfContainer}>
				<div className={classes.description}>
					<Typography type="headline" component="h1">
						{file.name}
					</Typography>
					<Typography className={classes.desktopDescription} component="p">
						{file.description}
					</Typography>
				</div>
				<Fullscreen {...fullscreenProps}>
					<PDFViewer {...pdfViewerProps}/>
				</Fullscreen>
			</div>
			<Dashboard {...dashboardProps}/>
			<Footer classes={{container: classes.footer}}/>
		</MainTheme>
	);
};

PDFPage.propTypes = {
	url: PropTypes.string,
	file: PropTypes.object,
	title: PropTypes.string,
	classes: PropTypes.object.isRequired,
	pageNumber: PropTypes.number,
	pageNumbers: PropTypes.number,
	isFullscreen: PropTypes.bool.isRequired,
	width: PropTypes.number.isRequired,
	handleGoBack: PropTypes.func.isRequired,
	onLoadListener: PropTypes.func.isRequired,
	setPageNumber: PropTypes.func.isRequired,
	setFullscreen: PropTypes.func.isRequired,
	zoomIn: PropTypes.func.isRequired,
	zoomOut: PropTypes.func.isRequired
};

PDFPage.defaultProps = {
	url: '',
	file: {},
	title: '',
	pageNumbers: 0,
	pageNumber: 0
};

export default withStyles(styles)(PDFPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/file/pdf/pdf-page.jsx